import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationService } from '../organization.service';
import { Organization } from 'src/app/services/organization.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';  // Add FormBuilder and FormGroup
import { User } from 'src/app/services/user';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/auth.service';
import { UserDataService } from 'src/app/services/user-data-service';


@Component({
    selector: 'app-select-organization-dialog',
    templateUrl: './select-organization-dialog.component.html',
    styleUrls: ['./select-organization-dialog.component.css'],
    standalone: false
})
export class SelectOrganizationDialogComponent implements OnInit {
  dialogTitle: string;
  organizations: Organization[] = [];
  organizationForm: FormGroup;  // Define the FormGroup
  moduleType:string='';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,  // Inject FormBuilder
    private organizationService: OrganizationService,  // Inject OrganizationService
    private userDataService:UserDataService,
    private dialogRef: MatDialogRef<SelectOrganizationDialogComponent>
  ) {
    
    this.organizations = data.organizations || [];  // Assign passed organizations
    this.moduleType=data.moduletype;
    this.dialogTitle = data.title || (this.moduleType === undefined ? 'Select Organization' : 'Change Organization');
   // console.log("module type==",this.moduleType);
    this.organizationForm = this.fb.group({   // Initialize FormGroup
      organization: [null, Validators.required]  // Define the organization control
    });
  }

  ngOnInit(): void {
    // If needed, any additional initialization can go here
  }

  onSave(): void {
    if (this.organizationForm.valid) {
      const selectedOrgId = this.organizationForm.value.organization;   
      // Save the selected organization ID in localStorage
      const orgname=this.organizationService.setSelectedOrganization(selectedOrgId.toString());
     // localStorage.setItem('selectedOrganizationId', selectedOrgId.toString());  // Storing as a string
      this.userDataService.setSelectedOrganization(selectedOrgId);
      this.userDataService.setOrgId(selectedOrgId);
      // You can pass the selected organization ID back to the parent component
      this.dialogRef.close({ status: true, organizationId: selectedOrgId });
      
    }
  }

  onCancel(): void {
    this.dialogRef.close({ status: false });  // Close dialog without passing any data
  }
}